import { render, staticRenderFns } from "./BindingsHistory.vue?vue&type=template&id=781cf64e&scoped=true"
import script from "./BindingsHistory.vue?vue&type=script&lang=js"
export * from "./BindingsHistory.vue?vue&type=script&lang=js"
import style0 from "./BindingsHistory.vue?vue&type=style&index=0&id=781cf64e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781cf64e",
  null
  
)

export default component.exports